import { render, staticRenderFns } from "./two.vue?vue&type=template&id=b2bfb95c&scoped=true&"
import script from "./two.vue?vue&type=script&lang=js&"
export * from "./two.vue?vue&type=script&lang=js&"
import style0 from "./two.vue?vue&type=style&index=0&id=b2bfb95c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bfb95c",
  null
  
)

export default component.exports